module.exports = __webpack_public_path__ + "static/img/slide3_x2.ebdc280.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide3_x2.webp
// module id = 80BR
// module chunks = 1